import { FC } from 'react';
import { AsyncThunk } from '@reduxjs/toolkit';

import { useGetItems, useAppSelector } from 'hooks';

import { Loading, RejectedMessage } from 'componets/ui';
import { CounterofferCard } from '../CounterofferCard';

import { RequestStatus } from 'utils/constants';

import {
	ICounterofferButton,
	ICounterofferItem,
	ICounterofferRow,
	Pager,
	PaginationParams,
} from 'models';

import styles from './index.module.scss';

type CounterofferListProps = {
	getRows: (v: ICounterofferItem) => ICounterofferRow[];
	pager: Pager;
	items: ICounterofferItem[];
	getButtons: (v: ICounterofferItem) => ICounterofferButton[];
	callback: AsyncThunk<any, PaginationParams | undefined, {}>;
	callbackMore: AsyncThunk<any, PaginationParams | undefined, {}>;
	isSent?: boolean;
};

export const CounterofferList: FC<CounterofferListProps> = ({
	getRows,
	pager,
	items,
	getButtons,
	callback,
	callbackMore,
	isSent,
}) => {
	const status = useAppSelector((state) => state.secondaryMarket.status);

	const isLoading = status === RequestStatus.PENDING;

	const { ref, isLoadingMore } = useGetItems({
		isLoading,
		callbackMore,
		pager,
		callback,
		isSent,
	});

	return (
		<div className={styles.root}>
			{status === RequestStatus.REJECTED ? (
				<RejectedMessage />
			) : (
				<div className={styles.wrapper}>
					<div className={styles.items}>
						{items.map((item: ICounterofferItem) => (
							<CounterofferCard
								rows={getRows(item)}
								date={item.counterOffer.createdAt}
								title={item.sale.project.title}
								id={item.sale.loan.id}
								key={item.counterOffer.id}
								buttons={getButtons(item)}
								country={item.sale.country}
							/>
						))}
					</div>

					{items.length > 0 && <div ref={ref} className={styles.more} />}

					{isLoadingMore && <Loading />}
				</div>
			)}
		</div>
	);
};
